import classNames from 'classnames'
import React from 'react'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { useStockReportContext } from 'src/contexts/stock-report.context'
import { Security } from 'src/shared/security.dto'
import { convertToKebabCase } from 'src/shared/utils'

import * as styles from './cybertorial.module.scss'

export const Cybertorial: React.FC = () => {
  const { report } = useStockReportContext()
  const { security } = report

  return (
    <>
      <SectionHeader spacing={2}>
        Latest News & Insights for {security.ticker}
      </SectionHeader>
      <div className={'pods'}>
        {report.cybertorial.articles.map((article, index) => (
          <article
            key={index}
            className={classNames('pods__item', styles.cybertorialArticle)}
          >
            <div className={styles.cybertorialArticle__header}>
              <img
                className={styles.cybertorialArticle__image}
                src={`https://images.stockopedia.com/large/cybertorial/${article.imageUrl}`}
                alt={`${article.title} background image`}
                loading={'lazy'}
              />
              <div className={styles.cybertorialArticle__headerContent}>
                <h3>
                  <a
                    href={buildArticleUrl(security, article.articleUrl)}
                    dangerouslySetInnerHTML={{ __html: article.title }}
                  />
                </h3>
                <div className={styles.cybertorialArticle__meta}>
                  <time dateTime={article.date}>{article.date}</time>
                  &nbsp;&mdash;&nbsp;
                  <address>
                    <a href={`/contributors/${article.author.username}/`}>
                      {article.author.name}
                    </a>
                  </address>
                </div>
              </div>
            </div>
            <div className={styles.cybertorialArticle__content}>
              <p>{article.snippet}</p>
            </div>
          </article>
        ))}
      </div>
    </>
  )
}

function buildArticleUrl(security: Security, articleId: string): string {
  return `/articles/${convertToKebabCase(security.name)}-${articleId}}`
}
